// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DingtalkSquareFilledSvg from "@ant-design/icons-svg/es/asn/DingtalkSquareFilled";
import AntdIcon from '../components/AntdIcon';

var DingtalkSquareFilled = function DingtalkSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkSquareFilledSvg
  }));
};

DingtalkSquareFilled.displayName = 'DingtalkSquareFilled';
export default React.forwardRef(DingtalkSquareFilled);